import React from 'react';
import { motion } from "framer-motion";
import image1 from '../assets/sweet.PNG'
import image2 from '../assets/am.PNG'
import image3 from '../assets/3.png'
import image4 from '../assets/4.PNG'
import img5 from '../assets/img5.PNG'
import makeup from '../assets/makeup.PNG'
import img6 from '../assets/5.png'
import Needy from '../assets/needy.PNG'
import light from '../assets/light.PNG'
import news from '../assets/various.PNg'
import calculator from '../assets/Calculator.PNG'
import ema from '../assets/ema.png'
import speed from '../assets/Speeed.png'
import img111 from '../assets/111.png'


const AllProjects = () => {
    return (
        <div className='bg-black '>
            <div className="max-w-screen-xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 lg:mx-24 gap-2">
                <motion.div
                    className="mx-auto relative border  opacity-70 border-cyan-400 max-w-[400px] h-[350px] flex flex-col justify-end  mt-12
                           before:absolute before:top-[-120px] before:-ml-[110px] before:left-1/2 "
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.5 }}
                    transition={{ duration: 0.6 }}
                    variants={{
                        hidden: { opacity: 0, scale: 0.8 },
                        visible: { opacity: 1, scale: 1 },
                    }}
                >
                    <img src={img111} alt="" />
                    <p className="font-playfair text-center text-2xl mt-3 mb-3 ">  Courier jX </p>
                    <p className="text-center text-xl mb-5">
                        Courier-Parcel-Management
                    </p>
                    <div className="grid grid-cols-2">
                        <a
                            className="hover:opacity-50 text-deep-blue font-bold transition text-center duration-500  bg-cyan-400 p-3"
                            href="https://courier-service-beta.vercel.app/"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <button className=''>Live Site</button>
                        </a>
                        <a
                            className="hover:opacity-50 text-deep-blue font-bold text-center transition duration-500 bg-cyan-500 p-3"
                            href="https://github.com/Anjum109/courier-parcel-management"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <button>Github Link</button>
                        </a>
                        {/* <a
                             className="hover:opacity-50 text-deep-blue font-bold text-center transition duration-500 bg-cyan-600 p-3"
                             href="https://github.com/Anjum109/NeedyShop/tree/main/server%20site"
                             target="_blank"
                             rel="noreferrer"
                           >
                             <button>Server Site</button>
                           </a> */}
                    </div>

                </motion.div>
                <motion.div
                    className="mx-auto relative border  opacity-70 border-cyan-400 max-w-[400px] h-[350px] flex flex-col justify-end  mt-12
            before:absolute before:top-[-120px] before:-ml-[110px] before:left-1/2 "
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.5 }}
                    transition={{ duration: 0.6 }}
                    variants={{
                        hidden: { opacity: 0, scale: 0.8 },
                        visible: { opacity: 1, scale: 1 },
                    }}
                >
                    <img src={makeup} alt="" />
                    <p className="font-playfair text-center text-2xl mt-3 mb-3 ">  MakeUp Mania (Ongoing) </p>
                    <p className="text-center text-xl mb-5">
                        Makeup & Spa Salon
                    </p>
                    <div className="grid grid-cols-2">
                        <a
                            className="hover:opacity-50 text-deep-blue font-bold transition text-center duration-500  bg-cyan-400 p-3"
                            href="https://main--makeup-mania340.netlify.app/"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <button className=''>Live Site</button>
                        </a>
                        <a
                            className="hover:opacity-50 text-deep-blue font-bold text-center transition duration-500 bg-cyan-500 p-3"
                            href="https://github.com/Anjum109/makeup-mania"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <button>Client Side</button>
                        </a>
                        {/* <a
              className="hover:opacity-50 text-deep-blue font-bold text-center transition duration-500 bg-cyan-600 p-3"
              href="https://github.com/Anjum109/NeedyShop/tree/main/server%20site"
              target="_blank"
              rel="noreferrer"
            >
              <button>Server Site</button>
            </a> */}
                    </div>

                </motion.div>

                <motion.div
                    className="mx-auto relative border  opacity-70 border-cyan-400 max-w-[400px] h-[350px] flex flex-col justify-end  mt-12
            before:absolute before:top-[-120px] before:-ml-[110px] before:left-1/2 "
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.5 }}
                    transition={{ duration: 0.6 }}
                    variants={{
                        hidden: { opacity: 0, scale: 0.8 },
                        visible: { opacity: 1, scale: 1 },
                    }}
                >
                    <img src={Needy} alt="" />
                    <p className="font-playfair text-center text-2xl mt-3 mb-3 ">  Needy Shop (Ongoing) </p>
                    <p className="text-center text-xl mb-5">
                        Groceries (Frontend)
                    </p>
                    <div className="grid grid-cols-3">
                        <a
                            className="hover:opacity-50 text-deep-blue font-bold transition text-center duration-500  bg-cyan-400 p-3"
                            href="https://needyshop-4a73b.web.app/"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <button className=''>Live Site</button>
                        </a>
                        <a
                            className="hover:opacity-50 text-deep-blue font-bold text-center transition duration-500 bg-cyan-500 p-3"
                            href="https://github.com/Anjum109/NeedyShopClientSite"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <button>Client Side</button>
                        </a>
                        <a
                            className="hover:opacity-50 text-deep-blue font-bold text-center transition duration-500 bg-cyan-600 p-3"
                            href="https://github.com/Anjum109/NeedyShop/tree/main/server%20site"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <button>Server Site</button>
                        </a>
                    </div>

                </motion.div>
                <motion.div
                    className="mx-auto relative border  opacity-70 border-cyan-400 max-w-[400px] h-[350px] flex flex-col justify-end  mt-12
            before:absolute before:top-[-120px] before:-ml-[110px] before:left-1/2 "
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.5 }}
                    transition={{ duration: 0.6 }}
                    variants={{
                        hidden: { opacity: 0, scale: 0.8 },
                        visible: { opacity: 1, scale: 1 },
                    }}
                >
                    <img src={light} alt="" />
                    <p className="font-playfair text-center text-2xl mt-3 mb-3 ">Light Attic</p>
                    <p className="text-center text-xl mb-5">
                        Pet adoption Website (Full Stack)
                    </p>
                    <div className="grid grid-cols-3">
                        <a
                            className="hover:opacity-50 text-deep-blue font-bold transition text-center duration-500  bg-cyan-400 p-3"
                            href="https://light-attic.web.app/"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <button className=''>Live Site</button>
                        </a>
                        <a
                            className="hover:opacity-50 text-deep-blue font-bold text-center transition duration-500 bg-cyan-500 p-3"
                            href="https://github.com/Anjum109/light-attic"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <button>Client Side</button>
                        </a>
                        <a
                            className="hover:opacity-50 text-deep-blue font-bold text-center transition duration-500 bg-cyan-600 p-3"
                            href="https://github.com/Anjum109/light-attic-server"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <button>Server Site</button>
                        </a>
                    </div>

                </motion.div>
                <motion.div
                    className="mx-auto relative border  opacity-70 border-cyan-400 max-w-[400px] h-[350px] flex flex-col justify-end  mt-12
            before:absolute before:top-[-120px] before:-ml-[110px] before:left-1/2 "
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.5 }}
                    transition={{ duration: 0.6 }}
                    variants={{
                        hidden: { opacity: 0, scale: 0.8 },
                        visible: { opacity: 1, scale: 1 },
                    }}
                >
                    <img src={image1} alt="" />
                    <p className="font-playfair text-center text-2xl mt-3 mb-3 ">SWEET REPEATS</p>
                    <p className="text-center text-xl mb-5">
                        Product Resale Website
                    </p>
                    <div className="grid grid-cols-3">
                        <a
                            className="hover:opacity-50 text-deep-blue font-bold transition text-center duration-500  bg-cyan-400 p-3"
                            href="https://sweet-repeats.web.app/"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <button className=''>Live Site</button>
                        </a>
                        <a
                            className="hover:opacity-50 text-deep-blue font-bold text-center transition duration-500 bg-cyan-500 p-3"
                            href="https://github.com/Anjum109/Sweet-Repeats-ClientSite"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <button>Client Side</button>
                        </a>
                        <a
                            className="hover:opacity-50 text-deep-blue font-bold text-center transition duration-500 bg-cyan-600 p-3"
                            href="https://github.com/Anjum109/Sweet-Repeats-ServerSite"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <button>Server Site</button>
                        </a>
                    </div>

                </motion.div>

                <motion.div
                    className="mx-auto relative border border-cyan-400 max-w-[400px] h-[350px] flex flex-col justify-end mt-12
            before:absolute before:top-[-120px] before:-ml-[110px] before:left-1/2 "
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.5 }}
                    transition={{ delay: 0.2, duration: 0.6 }}
                    variants={{
                        hidden: { opacity: 0, scale: 0.8 },
                        visible: { opacity: 1, scale: 1 },
                    }}
                >
                    <img className="w-full" src={image2} alt="" />
                    <p className="font-playfair text-center text-2xl  mt-3 mb-3">AL Dental Solution</p>
                    <p className="text-center text-xl mb-5">
                        Service Review Website
                    </p>
                    <div>
                        <div className="grid grid-cols-3">
                            <a
                                className="hover:opacity-50 transition text-deep-blue font-bold text-center duration-500  bg-cyan-400 p-3"
                                href="https://am-dental-solution.web.app/"
                                target="_blank"
                                rel="noreferrer"
                            >
                                <button className=''>Live Site</button>
                            </a>
                            <a
                                className="hover:opacity-50 text-center text-deep-blue font-bold transition duration-500 bg-cyan-500 p-3"
                                href="https://github.com/Anjum109/Al-Dental-Solution-ClientSite"
                                target="_blank"
                                rel="noreferrer"
                            >
                                <button>Client Side</button>
                            </a>
                            <a
                                className="hover:opacity-50 text-center transition text-deep-blue font-bold duration-500 bg-cyan-600 p-3"
                                href="https://github.com/Anjum109/Al-Dental-Solution-ServerSite"
                                target="_blank"
                                rel="noreferrer"
                            >
                                <button>Server Site</button>
                            </a>
                        </div>

                    </div>
                </motion.div>

                <motion.div
                    className="mx-auto relative border border-cyan-400 max-w-[400px] h-[350px] flex flex-col justify-end mt-12
            before:absolute before:top-[-120px] before:-ml-[110px] before:left-1/2 "
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.5 }}
                    transition={{ delay: 0.4, duration: 0.6 }}
                    variants={{
                        hidden: { opacity: 0, scale: 0.8 },
                        visible: { opacity: 1, scale: 1 },
                    }}
                >
                    <img src={image3} alt="" />
                    <p className="font-playfair text-2xl text-center  mt-3 mb-3">BETA LEARNING</p>
                    <p className="text-center text-xl mb-5">
                        Learning Platform Website
                    </p>
                    <div className="grid grid-cols-3">
                        <a
                            className="hover:opacity-50 transition text-deep-blue font-bold text-center duration-500  bg-cyan-400 p-3"
                            href="https://beta-learning.web.app/"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <button className=''>Live Site</button>
                        </a>
                        <a
                            className="hover:opacity-50 text-center text-deep-blue font-bold transition duration-500 bg-cyan-500 p-3"
                            href="https://github.com/Anjum109/Beta-Learning-ClientSide"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <button>Client Side</button>
                        </a>
                        <a
                            className="hover:opacity-50 text-center transition text-deep-blue font-bold duration-500 bg-cyan-600 p-3"
                            href="https://github.com/Anjum109/Beta-Learning-ServerSide"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <button>Server Site</button>
                        </a>
                    </div>
                </motion.div>

                <motion.div
                    className="mx-auto relative border border-cyan-400 max-w-[400px] h-[350px] flex flex-col justify-end mt-12
            before:absolute before:top-[-120px] before:-ml-[110px] before:left-1/2 "
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.5 }}
                    transition={{ delay: 0.4, duration: 0.6 }}
                    variants={{
                        hidden: { opacity: 0, scale: 0.8 },
                        visible: { opacity: 1, scale: 1 },
                    }}
                >
                    <img src={image4} alt="" />
                    <p className="font-playfair text-2xl text-center  mt-3 mb-3">Edits From India</p>
                    <p className="text-center text-xl mb-5">
                        Basic Frontend Website
                    </p>
                    <div className="grid grid-cols-2">
                        <a
                            className="hover:opacity-50 transition text-deep-blue font-bold text-center duration-500  bg-cyan-400 p-3"
                            href="https://sensational-hamster-fa423b.netlify.app"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <button className=''>Live Site</button>
                        </a>
                        <a
                            className="hover:opacity-50 transition text-deep-blue font-bold text-center duration-500  bg-cyan-500 p-3"
                            href="https://github.com/Anjum109/Edits-from-india"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <button className=''>Github Code</button>
                        </a>
                    </div>
                </motion.div>
                <motion.div
                    className="mx-auto relative border border-cyan-400 max-w-[400px] h-[350px] flex flex-col justify-end mt-12
            before:absolute before:top-[-120px] before:-ml-[110px] before:left-1/2 "
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.5 }}
                    transition={{ delay: 0.4, duration: 0.6 }}
                    variants={{
                        hidden: { opacity: 0, scale: 0.8 },
                        visible: { opacity: 1, scale: 1 },
                    }}
                >
                    <img src={img5} alt="" />
                    <p className="font-playfair text-2xl text-center  mt-3 mb-3">Learning State</p>
                    <p className="text-center text-xl mb-5">
                        JavaScript project
                    </p>
                    <div className="grid grid-cols-2">
                        <a
                            className="hover:opacity-50 transition text-deep-blue font-bold text-center duration-500  bg-cyan-400 p-3"
                            href="https://dynamic-quokka-a93008.netlify.app/"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <button className=''>Live Site</button>
                        </a>
                        <a
                            className="hover:opacity-50 transition text-deep-blue font-bold text-center duration-500  bg-cyan-500 p-3"
                            href="https://github.com/Anjum109/Learning-State"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <button className=''>Github Code</button>
                        </a>
                    </div>
                </motion.div>
                <motion.div
                    className="mx-auto relative border border-cyan-400 max-w-[400px] h-[350px] flex flex-col justify-end mt-12
            before:absolute before:top-[-120px] before:-ml-[110px] before:left-1/2 "
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.5 }}
                    transition={{ delay: 0.4, duration: 0.6 }}
                    variants={{
                        hidden: { opacity: 0, scale: 0.8 },
                        visible: { opacity: 1, scale: 1 },
                    }}
                >
                    <img src={img6} alt="" />
                    <p className="font-playfair text-2xl text-center  mt-3 mb-3">Fitness History</p>
                    <p className="text-center text-xl mb-5">
                        JavaScript project
                    </p>
                    <div className="grid grid-cols-2">
                        <a
                            className="hover:opacity-50 transition text-deep-blue font-bold text-center duration-500  bg-cyan-400 p-3"
                            href="https://magnificent-scone-fe5cec.netlify.app/"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <button className=''>Live Site</button>
                        </a>
                        <a
                            className="hover:opacity-50 transition text-deep-blue font-bold text-center duration-500  bg-cyan-500 p-3"
                            href="https://github.com/Anjum109/Fitness-History"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <button className=''>Github Code</button>
                        </a>
                    </div>
                </motion.div>
                <motion.div
                    className="mx-auto relative border  opacity-70 border-cyan-400 max-w-[400px] h-[350px] flex flex-col justify-end  mt-12
            before:absolute before:top-[-120px] before:-ml-[110px] before:left-1/2 "
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.5 }}
                    transition={{ duration: 0.6 }}
                    variants={{
                        hidden: { opacity: 0, scale: 0.8 },
                        visible: { opacity: 1, scale: 1 },
                    }}
                >
                    <img src={news} alt="" />
                    <p className="font-playfair text-center text-2xl mt-3 mb-3 ">  Various News</p>
                    <p className="text-center text-xl mb-5">
                        Javascript project
                    </p>
                    <div className="grid grid-cols-1">
                        <a
                            className="hover:opacity-50 text-deep-blue font-bold transition text-center duration-500  bg-cyan-400 p-3"
                            href="https://reliable-florentine-117e2c.netlify.app/"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <button className=''>Live Site</button>
                        </a>
                        {/* <a
                            className="hover:opacity-50 text-deep-blue font-bold text-center transition duration-500 bg-cyan-500 p-3"
                            href="https://github.com/Anjum109/light-attic"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <button>Client Side</button>
                        </a>
                        <a
                            className="hover:opacity-50 text-deep-blue font-bold text-center transition duration-500 bg-cyan-600 p-3"
                            href="https://github.com/Anjum109/light-attic-server"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <button>Server Site</button>
                        </a> */}
                    </div>

                </motion.div>
                <motion.div
                    className="mx-auto relative border  opacity-70 border-cyan-400 max-w-[400px] h-[350px] flex flex-col justify-end  mt-12
            before:absolute before:top-[-120px] before:-ml-[110px] before:left-1/2 "
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.5 }}
                    transition={{ duration: 0.6 }}
                    variants={{
                        hidden: { opacity: 0, scale: 0.8 },
                        visible: { opacity: 1, scale: 1 },
                    }}
                >
                    <img src={calculator} alt="" />
                    <p className="font-playfair text-center text-2xl mt-3 mb-3 ">Calculator</p>
                    <p className="text-center text-xl mb-5">
                        Using JavaScript
                    </p>
                    <div className="grid grid-cols-1">
                        <a
                            className="hover:opacity-50 text-deep-blue font-bold transition text-center duration-500  bg-cyan-400 p-3"
                            href="https://anjum109.github.io/Calculator/"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <button className=''>Live Site</button>
                        </a>
                        {/* <a
                            className="hover:opacity-50 text-deep-blue font-bold text-center transition duration-500 bg-cyan-500 p-3"
                            href="https://github.com/Anjum109/light-attic"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <button>Client Side</button>
                        </a>
                        <a
                            className="hover:opacity-50 text-deep-blue font-bold text-center transition duration-500 bg-cyan-600 p-3"
                            href="https://github.com/Anjum109/light-attic-server"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <button>Server Site</button>
                        </a> */}
                    </div>

                </motion.div>
                <motion.div
                    className="mx-auto relative border  opacity-70 border-cyan-400 max-w-[400px] h-[350px] flex flex-col justify-end  mt-12
            before:absolute before:top-[-120px] before:-ml-[110px] before:left-1/2 "
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.5 }}
                    transition={{ duration: 0.6 }}
                    variants={{
                        hidden: { opacity: 0, scale: 0.8 },
                        visible: { opacity: 1, scale: 1 },
                    }}
                >
                    <img src={ema} alt="" />
                    <p className="font-playfair text-center text-2xl mt-3 mb-3 ">Ema John</p>
                    <p className="text-center text-xl mb-5">
                        Using JavaScript
                    </p>
                    <div className="grid grid-cols-1">
                        <a
                            className="hover:opacity-50 text-deep-blue font-bold transition text-center duration-500  bg-cyan-400 p-3"
                            href="https://meek-taffy-4675f9.netlify.app/"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <button className=''>Live Site</button>
                        </a>
                        {/* <a
                            className="hover:opacity-50 text-deep-blue font-bold text-center transition duration-500 bg-cyan-500 p-3"
                            href="https://github.com/Anjum109/light-attic"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <button>Client Side</button>
                        </a>
                        <a
                            className="hover:opacity-50 text-deep-blue font-bold text-center transition duration-500 bg-cyan-600 p-3"
                            href="https://github.com/Anjum109/light-attic-server"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <button>Server Site</button>
                        </a> */}
                    </div>

                </motion.div>
                <motion.div
                    className="mx-auto relative border  opacity-70 border-cyan-400 max-w-[400px] h-[350px] flex flex-col justify-end  mt-12
            before:absolute before:top-[-120px] before:-ml-[110px] before:left-1/2 "
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.5 }}
                    transition={{ duration: 0.6 }}
                    variants={{
                        hidden: { opacity: 0, scale: 0.8 },
                        visible: { opacity: 1, scale: 1 },
                    }}
                >
                    <img src={speed} alt="" />
                    <p className="font-playfair text-center text-2xl mt-3 mb-3 ">Speed Typer</p>
                    <p className="text-center text-xl mb-5">
                        Using JavaScript
                    </p>
                    <div className="grid grid-cols-1">
                        <a
                            className="hover:opacity-50 text-deep-blue font-bold transition text-center duration-500  bg-cyan-400 p-3"
                            href="https://jovial-flan-b2709d.netlify.app/"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <button className=''>Live Site</button>
                        </a>
                        {/* <a
                            className="hover:opacity-50 text-deep-blue font-bold text-center transition duration-500 bg-cyan-500 p-3"
                            href="https://github.com/Anjum109/light-attic"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <button>Client Side</button>
                        </a>
                        <a
                            className="hover:opacity-50 text-deep-blue font-bold text-center transition duration-500 bg-cyan-600 p-3"
                            href="https://github.com/Anjum109/light-attic-server"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <button>Server Site</button>
                        </a> */}
                    </div>

                </motion.div>
            </div>
        </div>
    );
};

export default AllProjects;